export const hideScroll = () => {
    document.querySelector("html").style.overflowY = "hidden";
    document.body.style.overflowY = "hidden";
}

export const restoreScroll = () => {
    document.querySelector("html").style.overflowY = "";
    document.body.style.overflowY = "";
}